import type { SearchTileDensity } from '../searchTileDensity'

const DEFAULT_GROUPED_HOTEL_INCLUSIONS = 3
const COMPACT_HOTEL_INCLUSIONS = 3
const COMPACT_GROUPED_HOTEL_INCLUSIONS = 2

type UrgencyTagVariant = 'compact' | 'default'

interface AccommodationSearchTileView {
  readonly density: SearchTileDensity
  readonly isCompact: boolean
  readonly showMeta: boolean
  readonly showCancellationPolicy: boolean
  readonly showUpgradeBanner: boolean
  readonly showFeatureTitle: boolean
  readonly showSecondaryLuxPlusPromos: boolean
  readonly useCompactPricing: boolean
  readonly hotelMaxTotalInclusions?: number
  readonly groupedHotelMaxTotalInclusions: number
  readonly bedbankMaxInclusions?: number
  readonly hideBedbankLuxPlusPricing: boolean
  readonly hideIncludesTaxesAndFees: boolean
  readonly showLocationOverline: boolean
  readonly showLocationDistanceLabels: boolean
  readonly urgencyTagVariant: UrgencyTagVariant
}

const DEFAULT_ACCOMMODATION_SEARCH_TILE_VIEW: AccommodationSearchTileView = {
  density: 'default',
  isCompact: false,
  showMeta: true,
  showCancellationPolicy: true,
  showUpgradeBanner: true,
  showFeatureTitle: true,
  showSecondaryLuxPlusPromos: true,
  useCompactPricing: false,
  groupedHotelMaxTotalInclusions: DEFAULT_GROUPED_HOTEL_INCLUSIONS,
  hideBedbankLuxPlusPricing: false,
  hideIncludesTaxesAndFees: false,
  showLocationOverline: true,
  showLocationDistanceLabels: true,
  urgencyTagVariant: 'default',
}

const COMPACT_ACCOMMODATION_SEARCH_TILE_VIEW: AccommodationSearchTileView = {
  density: 'compact',
  isCompact: true,
  showMeta: false,
  showCancellationPolicy: false,
  showUpgradeBanner: false,
  showFeatureTitle: false,
  showSecondaryLuxPlusPromos: false,
  useCompactPricing: true,
  hotelMaxTotalInclusions: COMPACT_HOTEL_INCLUSIONS,
  groupedHotelMaxTotalInclusions: COMPACT_GROUPED_HOTEL_INCLUSIONS,
  hideBedbankLuxPlusPricing: true,
  hideIncludesTaxesAndFees: true,
  showLocationOverline: true,
  showLocationDistanceLabels: false,
  urgencyTagVariant: 'compact',
}

export function getAccommodationSearchTileView(density: SearchTileDensity): AccommodationSearchTileView {
  return density === 'compact' ?
    COMPACT_ACCOMMODATION_SEARCH_TILE_VIEW :
    DEFAULT_ACCOMMODATION_SEARCH_TILE_VIEW
}
